//angular
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';

//node-modules
import { RxStompService } from '@stomp/ng2-stompjs';

//libs
import { ApplicationManagementModule } from '@nrwl/application-management';
import { ViewTableModule } from '@nrwl/view-table';
import { CommonLibModule, EntityCacheProvider, LabelsService, UserAuth } from '@nrwl/common-lib';
import { FusionAuthenticationModule } from '@nrwl/fusion-authentication';
import { WizardModule } from '@nrwl/wizard';
import { TestSetupModule } from '@nrwl/test-setup';
import { AboutComponent } from './about/about.component';
import { CommonMaterialModule } from '@nrwl/common-material';
import { LicensesModule } from '@nrwl/licenses';

//local
import { stompConfig } from '../../../stomp.config';
import { environment } from '../../environments/environment';
import { NavbarModule } from '../navbar/navbar.module';
import { HomeComponent } from './home/home.component';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { PerspectiveLayoutComponent } from './perspective.layout/perspective.layout.component';
import { MainEntityService } from './services/entity/main.entity.service';

import { getCustomPaginator } from './custom.paginator';
import { DrillDirectionEventProvider } from '@nrwl/smart-search';
import { AdvancedSearchModule } from '@nrwl/advanced-search';
import { SmartSearchBaseModule } from '@nrwl/smart-search-base';
import { ViaviTabulatorModule } from 'libs/viavi-tabulator/src';
import { TestSetupRouterModule } from '@nrwl/test-setup-router';
import { UserComponent } from './user/user.component';
import { SideBarNavComponent } from './fusion-ui-sidebar/fusion-ui-sidebar.component';

export function init_app(labelService: LabelsService) {
  return () => labelService.initializeLabelData('fusion-ui-label.json'); // eslint-disable-line
}

@NgModule({
  imports: [
    AdvancedSearchModule,
    CommonModule,
    CommonMaterialModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    NavbarModule,
    ViewTableModule,
    ViaviTabulatorModule,
    FusionAuthenticationModule,
    CommonLibModule,
    WizardModule,
    TestSetupModule,
    ApplicationManagementModule,
    LicensesModule,
    SmartSearchBaseModule,
    TestSetupRouterModule
  ],
  declarations: [
    HomeComponent,
    SideBarNavComponent,
    PerspectiveLayoutComponent,
    UserComponent,
    AboutComponent
  ],
  providers: [
    { provide: 'environments', useValue: environment },
    LabelsService,
    { provide: APP_INITIALIZER, useFactory: init_app, deps: [LabelsService], multi: true },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptcha_key
      }
    },
    RxStompService,
    { provide: 'defaultSocketsConfig', useValue: stompConfig },
    { provide: 'userAuth', useExisting: UserAuth },
    { provide: 'labelsService', useExisting: LabelsService },
    { provide: EntityCacheProvider, useExisting: MainEntityService },
    DrillDirectionEventProvider,
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { horizontalPosition: 'left', duration: 6000 }
    },
    { provide: MatPaginatorIntl, useValue: getCustomPaginator() }
  ],
  exports: [HomeComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class FusionUiModule {}
